import { configureBrowserTelemetry } from '@firmable/telemetry/browser';

/**
 * Browser RUM entrypoint.
 *
 * Next resolves `instrumentation-client` via a compiler alias that is gated
 * only on the client build, not on the router — so this works for the Pages
 * Router. It runs before React hydrates, which is what lets Logfire own the
 * global tracer before the first axios request fires.
 *
 * Spans go to our own origin (`/_tel/v1/traces`) and `apps/web/proxy.ts`
 * attaches the write token server-side, so no token ships in the bundle.
 */
const apiEndpoint = process.env.NEXT_PUBLIC_API_APP_ENDPOINT;

if (apiEndpoint) {
  try {
    configureBrowserTelemetry({
      service: 'web',
      clientSource: 'app',
      traceUrl: process.env.NEXT_PUBLIC_LOGFIRE_TRACE_URL ?? '/_tel/v1/traces',
      apiOrigin: apiEndpoint,
      env: {
        // VERCEL_* is not inlined into client bundles; next.config.js promotes
        // these two into NEXT_PUBLIC_* so the resource builder has real values.
        ENVIRONMENT: process.env.NEXT_PUBLIC_LOGFIRE_ENVIRONMENT,
        VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
        NEXT_PUBLIC_LOGFIRE_SERVICE_VERSION: process.env.NEXT_PUBLIC_LOGFIRE_SERVICE_VERSION,
      },
      // The real cost lever: this is what emits the per-asset resourceFetch
      // spans. `resourceTiming.detail` only shrinks payload bytes.
      documentLoadSampleRate: Number(process.env.NEXT_PUBLIC_LOGFIRE_DOCLOAD_SAMPLE ?? '0.1'),
    });
  } catch (error) {
    // Instrumentation must never break the app.
    // eslint-disable-next-line no-console
    console.warn('[telemetry] browser init failed', error);
  }
}
